<template>
  <v-dialog v-model="dialog" width="960px">
    <v-card>
      <v-card-title class="mx-3">
        {{ queueCode ? queueCode : '' }}{{ $t("SettlementQueue.Fields.details") }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-row dense class="mx-5">
        <v-col cols="12" sm="5">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="keyword"
              v-model="materialKeyword"
              @text="KeyWord = $event"
              :label="
                settings &&
                (settings.material_name_display_type == 2 ||
                  settings.material_name_display_type == 3)
                  ? $t('Material.materialNameAndCodeKeyword')
                  : $t('Material.materialNameKeyword')
              "
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="2" align-self="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                text
                class="caption font-weight-bold grey--text"
                color="primary"
                @click.stop="onSearch()"
              >
                <v-icon small class="pe-1">fa-search</v-icon>
                {{ $t("Search.search") }}
              </v-btn>
            </template>
            <span>{{ $t("Search.searchTip") }}</span>
          </v-tooltip>
        </v-col>

<!--        <v-col cols="12" sm="6">-->
<!--          <v-row dense align="center" class="pa-1">-->
<!--            <div-->
<!--              class="caption grey&#45;&#45;text input-chip-group-label"-->
<!--              :class="-->
<!--                $vuetify.theme.dark ? 'text&#45;&#45;lighten-1' : 'text&#45;&#45;darken-1'-->
<!--              "-->
<!--            >-->
<!--              {{ $t("Material.Fields.public_flg") }}-->
<!--            </div>-->
<!--            <v-chip-group v-model="publicFlgs" column multiple class="mx-1">-->
<!--              <v-chip-->
<!--                small-->
<!--                label-->
<!--                filter-->
<!--                class="mx-1"-->
<!--                color="primary"-->
<!--                text-color="white"-->
<!--                :key="1"-->
<!--                :value="1"-->
<!--                >{{ $t("Material.publicFlgs.on") }}</v-chip-->
<!--              >-->
<!--              <v-chip-->
<!--                small-->
<!--                label-->
<!--                filter-->
<!--                class="mx-1"-->
<!--                color="grey"-->
<!--                text-color="white"-->
<!--                :key="0"-->
<!--                :value="0"-->
<!--                >{{ $t("Material.publicFlgs.off") }}</v-chip-->
<!--              >-->
<!--            </v-chip-group>-->
<!--          </v-row>-->
<!--        </v-col>-->
      </v-row>
      <v-data-table
        :headers="headers"
        :items="queueBills"
        :loading="loading"
        :options.sync="dialogOptions"
        :page.sync="dialogPaging.page"
        :server-items-length="dialogPaging.count"
        disable-sort
        multi-sort
        class="elevation-0 px-6"
        v-resize="resizeHeader"
        height="340px"
        :footer-props="$t('$config.footer-props')"
        fixed-header
      >
        <template v-slot:item.bill_type="{ item }">
          {{ item.bill_type_str }}
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            small
            label
            :color="item.status | billFlgsColor"
            :text-color="item.status | billFlgsTextColor"
          >
            {{ item.status | billFlgsText }}
          </v-chip>        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          class="elevation-1"
          @click="dialog = false"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Settlements from "@/api/settlements";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";

export default {
  name: "SettlementQueueBillsDialog",

  props: {
    value: Boolean,
    queueCode: String,
  },

  components: {
    SearcherKeyword,
  },

  computed: {
    headers() {
      let headers = [
        {
          text: i18n.t("ShopBillView.Fields.bill_code"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "bill_code",
        },
        {
          text: i18n.t("ShopBillView.Fields.bill_type"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "bill_type",
        },
        {
          text: i18n.t("ShopBillView.Fields.status"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "status",
        },
        {
          text: i18n.t("ShopBillView.Fields.month"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "month",
        },
        {
          text: i18n.t("ShopBillView.Fields.created"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "created",
        }
      ];
      return headers;
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    queueBills: [],
    dialogOptions: {},
    dialogPaging: {},
    materialKeyword: "",
  }),

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },
    onSearch() {
      this.materialKeyword = this.KeyWord;
    },

    getQueueBillsFromAPI() {
      let options = Object.assign({}, this.options, {
        queue_code: this.queueCode
      });
      Settlements.queueBills(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.queueBills = response.data.queue_bills;
            this.dialogPaging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.dialogOptions.page = 1;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    dialog: {
      handler() {
        this.$emit("input", null);
      },
    },
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = this.value;
          this.getQueueBillsFromAPI();
        } else {
          this.queueBills = [];
          this.dialogPaging = {};
        }
      },
    },
  },
};
</script>